import { z } from "zod";
import { draftPurposeSchema, draftStatusSchema } from "../enums.js";
import {
  isoDateTimeSchema,
  nonEmptyStringSchema,
  uuidSchema,
} from "../primitives.js";

export const emailDraftSchema = z.object({
  id: uuidSchema,
  hotel_id: uuidSchema,
  contact_id: uuidSchema.nullable(),
  purpose: draftPurposeSchema,
  subject: nonEmptyStringSchema,
  body_text: nonEmptyStringSchema,
  status: draftStatusSchema,
  source_claim_ids: z.array(uuidSchema),
  research_job_id: uuidSchema.nullable(),
  agent_run_id: uuidSchema.nullable(),
  approved_by: uuidSchema.nullable(),
  approved_at: isoDateTimeSchema.nullable(),
  rejection_reason: z.string().nullable(),
  created_at: isoDateTimeSchema,
  updated_at: isoDateTimeSchema,
});

export type EmailDraft = z.infer<typeof emailDraftSchema>;

export const createEmailDraftInputSchema = z.object({
  hotel_id: uuidSchema,
  contact_id: uuidSchema.optional().nullable(),
  purpose: draftPurposeSchema.default("initial"),
  instructions: z.string().optional(),
  research_job_id: uuidSchema.optional(),
});

export type CreateEmailDraftInput = z.infer<typeof createEmailDraftInputSchema>;

/** PATCH /v1/drafts/:id body (id comes from path). */
export const patchEmailDraftInputSchema = z.object({
  subject: nonEmptyStringSchema.optional(),
  body_text: nonEmptyStringSchema.optional(),
  purpose: draftPurposeSchema.optional(),
});

export type PatchEmailDraftInput = z.infer<typeof patchEmailDraftInputSchema>;

export const rejectEmailDraftBodySchema = z.object({
  reason: z.string().optional(),
});

export type RejectEmailDraftBody = z.infer<typeof rejectEmailDraftBodySchema>;

/** List item for approval queue (includes hotel label). */
export const emailDraftListItemSchema = emailDraftSchema.extend({
  hotel_name: nonEmptyStringSchema,
});

export type EmailDraftListItem = z.infer<typeof emailDraftListItemSchema>;

export const emailDraftListResponseSchema = z.object({
  items: z.array(emailDraftListItemSchema),
  next_cursor: z.string().nullable(),
});

export type EmailDraftListResponse = z.infer<
  typeof emailDraftListResponseSchema
>;
